import WeatherBlock from './weather-block';

document.querySelectorAll('.js-weatherBlock').forEach($element => new WeatherBlock($element));
